// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--2lBX4","parent":"parent--1fT5Q","listProfiles":"listProfiles--1TKmb","header":"header--2VLeO","content":"content--16QHF"};